import { Link } from 'react-router-dom';
import {  FaYoutube,FaTwitter, FaFacebook, FaInstagram } from 'react-icons/fa';
import { IoIosMail, IoMdCall } from 'react-icons/io';

const TopNav = () => {
    return (
   
        <div className="custom-container white hide-on-med-and-down">
            <div className="top-nav">
                <div>
                    <div className="main-logo">
                        <Link to="/" className="center-on-small-only"> 
                            <img src="/img/logo.svg" alt="Life Long Education Logo" className="logo" />
                        </Link> 
                    </div>         
                </div>
                <div>
                    <div className="nav-name">
                        <div className="main-name main-color-text is-uppercase mb-2">life long polytechnic</div>
                        <p className="is-size-6 grey-text text-darken-2">Labor omnia vincat.</p>
                    </div>
                </div>
                <div className="hide-on-small-only">
                    <div className="cont-of-two mb-4">
                        <IoIosMail fontSize="1.3rem" className="grey-text text-darken-2 mr-2"/>
                        <a href="mailto:lifelongcollege@gmail.com">                   
                            <span className="nav-email grey-text text-darken-2">lifelongcollege@gmail.com</span>
                        </a>
                    </div>
                    <div className="cont-of-two">
                        <IoMdCall fontSize="1.1rem" className="grey-text text-darken-2 mr-2"/>
                        <span>                      
                            <span className="nav-email grey-text text-darken-2">0787 625 134 / 0719 216 324</span>
                        </span>
                    </div>
                </div>
                <div className="hide-on-med-and-down btn-n-icons">
                    <Link to="/online-application" className="button is-small">Apply Online</Link>
                    <div className="nav-icons mt-4">
                        <a href="https://www.facebook.com/Life-Long-Polytechnic-105016771805634/" target="_blank" rel="noreferrer" className="make-icon-red">
                            <FaFacebook fontSize="1.1rem" className="mr-2 grey-text text-darken-2"/>
                        </a>
                        <a href="https://www.instagram.com/invites/contact/?i=155z9zr1uupd&utm_content=mup8gor" target="_blank" rel="noreferrer" className="make-icon-red">
                            <FaInstagram fontSize="1.1rem" className="mr-2 grey-text text-darken-2"/>
                        </a>
                        <a href="https://www.youtube.com/channel/UC-sJHuTUquADtt3VAfW-Q3A" target="_blank" rel="noreferrer" className="make-icon-red">
                            <FaYoutube fontSize="1.1rem" className="mr-2 grey-text text-darken-2"/>
                        </a>
                        <a href="#!" className="make-icon-red">
                            <FaTwitter fontSize="1.1rem" className="mr-2 grey-text text-darken-2"/>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    
     );
}
 
export default TopNav;